export const ORDER_TOAST_LIFETIME_MS = 5000;

export const SOCKET_RECONNECT_MIN_DELAY_MS = 1000;

export const SOCKET_RECONNECT_MAX_DELAY_MS = 30000;

export const SOCKET_MAX_RECONNECT_ATTEMPTS = 10;

export const TOKEN_REFRESH_LEEWAY_MS = 30000;

export const LAST_EVENT_ID_TTL_MS = 60 * 60 * 1000;

export const UNVIEWED_ORDERS_TTL_MS = 24 * 60 * 60 * 1000;
